import useFetchPosts  from './posts'


export default useFetchPosts
